import { APIHandler } from "../base";

export interface DemoQuestion {
    question: string;
    dateType: string;
    query: any;
}

export interface CubeQuery {
    measures?: string[];
    dimensions?: string[];
    timeDimensions?: Array<{
        dimension: string;
        dateRange?: string | [string, string];
        granularity?: string;
    }>;
    filters?: Array<{
        member?: string;
        dimension?: string;
        operator: string;
        values: string[];
    }>;
    limit?: number;
    offset?: number;
    order?: Record<string, "asc" | "desc">;
}

export interface CubeQueryResult {
    data: any[];
    annotation: {
        measures: Record<string, any>;
        dimensions: Record<string, any>;
        segments: Record<string, any>;
        timeDimensions: Record<string, any>;
    };
    query: any;
}

export interface CubeMeasure {
    name: string;
    title: string;
    shortTitle: string;
    type: string;
}

export interface CubeDimension {
    name: string;
    title: string;
    shortTitle: string;
    type: string;
}

export interface CubeMeta {
    measures: CubeMeasure[];
    dimensions: CubeDimension[];
}

/**
 * Get demo questions with native Cube.js queries
 */
export const fetchDemoQuestions = () =>
    APIHandler.get<DemoQuestion[]>("/statistics/demo-questions");

/**
 * Execute a Cube.js query
 */
export const executeQuery = (query: CubeQuery) =>
    APIHandler.post<CubeQueryResult>("/statistics/query", query);

/**
 * Get list of available cubes
 */
export const fetchCubeList = () => APIHandler.get<string[]>("/statistics/cubes");

/**
 * Get metadata for a specific cube
 */
export const fetchCubeMeta = (cubeName: string) =>
    APIHandler.get<CubeMeta>(`/statistics/cubes/${cubeName}/meta`);

/**
 * Get measures for a specific cube
 */
export const fetchCubeMeasures = (cubeName: string) =>
    APIHandler.get<CubeMeasure[]>(`/statistics/cubes/${cubeName}/measures`);

/**
 * Get dimensions for a specific cube
 */
export const fetchCubeDimensions = (cubeName: string) =>
    APIHandler.get<CubeDimension[]>(`/statistics/cubes/${cubeName}/dimensions`);

/**
 * Execute a full cube query with filters, pagination, etc.
 * This is the main query endpoint that replaces GET_CUBE_LIST RPC
 */
export interface CubeListParams {
    modelType?: string;
    filters?: any[];
    measures?: string[];
    groups?: any[];
    propsToShow?: string[];
    timeDimensions?: any[];
    limit?: number;
    startFrom?: number;
    sortBy?: any[];
}

export interface CubeListResult {
    list: any[];
    query: any;
    annotation: {
        measures: Record<string, any>;
        dimensions: Record<string, any>;
    };
    totalNumber: number;
}

export const fetchCubeListData = (params: CubeListParams) =>
    APIHandler.post<CubeListResult>("/statistics/query/list", params);
